<section>
  <div id="version-modal">
    <img
      src="assets/images/logos/LSS_LogoSmall.svg"
      alt="Leangroup Solutions Logo"
      width="36"
    />
    <div class="version-modal__content">
      <h2>
        {{ messageData?.title | titlecase }}
      </h2>
      <p
        class="version-modal__content--message"
        *ngIf="messageData.isInnerHtml"
        [innerHtml]="messageData?.message"
      ></p>
      <p
        class="version-modal__content--message"
        *ngIf="!messageData.isInnerHtml"
      >
        {{ messageData?.message }}
      </p>
    </div>
  </div>
  <div id="version-modal-footer">
    <button mat-button (click)="close()">
      {{ messageData?.buttonText || 'OK' | uppercase }}
    </button>
  </div>
</section>
